import React, { FC, useEffect, useState } from "react";
import AppHeader from "../../shared/components/AppHeader";
import { Table, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { SearchInput } from "../../shared/components/SearchInput";
import "./institute.scss";
import ButtonComponent from "../../shared/components/ButtonComponent";
import ToggleSwitch from "../../shared/components/ToggleSwitch";
import faker from "faker";
import CardMenu from "../../shared/components/CourseComponents/CardMenu";
import { InstituteForm } from "./InstituteForm";
import { generatePath, useHistory } from "react-router";
import { INSTITUTE_VIEW } from "../../routes/routeConstants/appRoutes";
import InstituteService from "../../services/InstituteService/institute.service";
import { Institutes } from "../../models/InstituteModel/institutes.model";
import PaginationComponent from "../../shared/components/PaginationComponent";
import DeleteAlert from "../../shared/components/DeleteAlert";
import { convertJSONToFormData } from "../../shared/utils/converJsonToFormData";

export const Institute: FC = (props: any) => {
  const [showInstituteForm, setInstituteFormVisibility] = useState(false);
  const [currentInstitute, setCurrentInstitute] = useState<Institutes | null>();
  const [institutes, setInstitutes] = useState<Institutes[]>([]);
  const [paginationMeta, setPaginationMeta] = useState<any>([]);
  const [currentPageNumber, setCurrentPageNumber] = useState<number>(1);
  const [deleteVisible, setDeleteVisibility] = useState(false);
  const [loading, setLoading] = useState(false)

  const history = useHistory();

  const fetchInstitutes = (params: any) => {
    setLoading(true)
    InstituteService.fetchInstitutes(
      params,
      (data) => {
        setLoading(false)
        if (props?.user?.roleName === 'instituteadmin' && data?.length) {
          let FilterData = data.filter(inst => inst?.id === props?.user?.instituteId)
          if (FilterData?.length)
            history.push(
              generatePath(INSTITUTE_VIEW, {
                instituteId: FilterData[0]?.id,
              }),
              FilterData[0]
            )
        } else
          setInstitutes(data);

      },
      () => { setLoading(false) },
      () => { }
    );
  };

  const handleToggle = (id: any, value: boolean) => {
    let payload = {
      institute: {
        is_active: value,
      },
    };
    const formData = convertJSONToFormData(payload);
    InstituteService.updateInstitute(
      id,
      formData,
      () => {
        fetchInstitutes({ page: currentPageNumber });
      },
      () => { },
      () => { }
    );
  };

  useEffect(() => {
    fetchInstitutes({ page: currentPageNumber });
  }, []);

  const handlePageChange = (page: number, pageSize: any) => {
    fetchInstitutes({ page: currentPageNumber });
    setCurrentPageNumber(page);
  };

  const handleSearch = (value: string) => {
    fetchInstitutes({ page: currentPageNumber, search: value });
  };

  const handleDelete = () => {
    InstituteService.deleteInstitute(
      currentInstitute?.id,
      () => {
        fetchInstitutes({ page: currentPageNumber });
        setDeleteVisibility(false);
        setCurrentInstitute(null);
      },
      () => { },
      () => { }
    );
  };

  return (
    <div className="page-view">
      <AppHeader
        headerText="Institute Management"
        showBreadCrumb={false}
        showFilter={false}
        showSearch={false}
        showButton={false}
      />
      <InstituteForm
        visible={showInstituteForm}
        closeHandler={() => {
          setInstituteFormVisibility(false);
          setCurrentInstitute(null);
        }}
        data={currentInstitute}
        refreshList={() => fetchInstitutes({})}
      />
      <DeleteAlert
        title={currentInstitute?.name}
        detail={(currentInstitute?.noOfBranches || 0) + " Branches"}
        visible={deleteVisible}
        setVisible={setDeleteVisibility}
        deleteText="institute"
        deleteWarning="This institute will be deleted permanently"
        handleDelete={handleDelete}
      />
      <div className="institute__container">
        {props?.user?.roleName === 'admin' && <div className="header__wrapper">
          <div className="header__left">
            <SearchInput
              placeholder={"Search by any institute"}
              onChange={(value) => handleSearch(value)}
            />
          </div>
          <div className="header__right">
            <ButtonComponent
              buttonContent="Add Institute"
              type="primary"
              iconLeft={<PlusOutlined />}
              onClick={() => {
                setCurrentInstitute(null);
                setInstituteFormVisibility(true);
              }}
            />
          </div>
        </div>}
        <Table
          loading={loading}
          onRow={(record) => {
            return {
              onClick: (event) => setCurrentInstitute(record),
            };
          }}
          className="institute__table"
          columns={[
            {
              title: "Institute",
              dataIndex: "name",
              key: "name",
              render: (text, record, index) => (
                <p
                  className="institute__name"
                  onClick={() =>
                    history.push(
                      generatePath(INSTITUTE_VIEW, {
                        instituteId: record?.id,
                      }),
                      record
                    )
                  }
                >
                  {record?.logoUrl && (
                    <span>
                      <img src={record?.logoUrl} />
                      {" "}
                    </span>
                  )}

                  {text}
                </p>
              ),
            },
            {
              title: "Contact Person",
              dataIndex: "contactPerson",
              key: "contactPerson",
            },
            {
              title: "Phone Number",
              dataIndex: "phoneNumber",
              key: "phoneNumber",
            },
            {
              title: "Email ID",
              dataIndex: "email",
              key: "email",
            },
            {
              title: "# of Branches",
              dataIndex: "noOfBranches",
              key: "noOfBranches",
            },
            props?.user?.roleName === 'admin'
              ? {
                dataIndex: "isActive",
                key: "isActive",
                render: (text, record) => (
                  <Space size="large" className="float-right">
                    <ToggleSwitch
                      checked={text}
                      handleChange={(value) => handleToggle(record?.id, value)}
                    />
                    <CardMenu
                      menuText="Institute"
                      handleEdit={() => setInstituteFormVisibility(true)}
                      handleDelete={() => setDeleteVisibility(true)}
                    />
                  </Space>
                ),
              }
              : {}
          ]}
          dataSource={institutes}
        />
        <PaginationComponent
          handlePageChange={handlePageChange}
          paginationMeta={paginationMeta}
        />
      </div>
    </div>
  );
};
